import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sidebar/phmax",
  "use": "sidebar/phmax-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sidebar/phmax\"><path d=\"M.812 12.366H0V7h1.014l2.467 3.546L6.055 7h1.014v5.366h-.811v-4.4l-2.339 3.235h-.854L.812 7.966v4.4zM10.277 11.145h2.459l-1.238-2.55-1.22 2.55zm3.048 1.22l-.398-.824h-2.84l-.391.825h-.731l2.01-4.174h1.055l2.018 4.174h-.723zM17.957 10.226L20 12.366h-.814l-1.661-1.745-1.678 1.745h-.805l2.06-2.127-1.977-2.047h.814l1.586 1.651 1.57-1.65h.805l-1.943 2.033z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol